import { render } from "./SignoutComponent.vue?vue&type=template&id=7358a7c4"
import script from "./SignoutComponent.vue?vue&type=script&lang=js"
export * from "./SignoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__